import {Checkbox, FormControlLabel} from '@mui/material'
import FormControl from '@mui/material/FormControl'
import {FormControlLabelProps} from '@mui/material/FormControlLabel/FormControlLabel'
import React from 'react'

export interface CheckboxWithLabelProps extends Pick<FormControlLabelProps, 'label' | 'labelPlacement' | 'disabled'> {
  onChange: (value: boolean, event: React.ChangeEvent<{}>) => void
  value: boolean
}

export const CheckboxWithLabel: React.FC<CheckboxWithLabelProps> = ({label, labelPlacement, onChange, value, disabled}) => {
  const onFormControlChange = (event: React.ChangeEvent<{}>) => {
    if (disabled) {
      return
    }
    onChange(!value, event)
  }

  return (
    <FormControl disabled={disabled}>
      <FormControlLabel
        style={{marginLeft: 0, justifyContent: 'flex-end'}}
        value={value.toString()}
        control={<Checkbox checked={value} color="primary" disabled={disabled} />}
        label={label}
        labelPlacement={labelPlacement}
        onChange={onFormControlChange}
        disabled={disabled}
      />
    </FormControl>
  )
}
